import { styled } from '@mui/system';

export const Page404Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
});

export const MessageTitleBig = styled('div')({
  fontSize: '5rem',
  fontWeight: 'bold',
  textAlign: 'center',
  color: '#d21919',
});

export const MessageTitleMedium = styled('div')({
  fontSize: '2rem',
  fontWeight: 'bold',
  textAlign: 'center',
  color: '#1976d2',
});
